import { Button, DottedBox, FoodsIcon, Typography } from "@foodpilot/foods";
import { useTranslation } from "react-i18next";

type NoPackagingsProps = {
    openModal: () => void;
};
export const NoPackagings = (props: NoPackagingsProps) => {
    const { t } = useTranslation();

    return (
        <DottedBox>
            <div
                style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    padding: "2rem",
                }}
            >
                <Typography variant="big-medium">{t("no_packaging_added")}</Typography>
                <Button variant="text" startIcon={<FoodsIcon icon="plus" size={2} />} onClick={props.openModal}>
                    {t("ajouter_ou_retirer_des_emballages")}
                </Button>
            </div>
        </DottedBox>
    );
};
